(function (module) {
    'use strict';

    module.directive('validateSchema', function($http, $q, $parse) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                let lastValue;
                ngModel.$asyncValidators.validateSchema = (modelValue, viewValue) => {
                    if (!viewValue || lastValue === viewValue) return $q.resolve();
                    lastValue = viewValue;

                    const appTemplate = $parse(attrs.appTemplate)(scope);

                    // Clear schema fields
                    ['fields', 'meta', 'events', 'styles'].forEach(prop => {
                        delete appTemplate[prop];
                    });

                    return $http.get(viewValue).then(({ status, data }) => {
                        if (status === 200 && typeof data === 'object') {
                            // Set schema props
                            ['fields', 'meta', 'events', 'styles'].forEach(prop => {
                                if (data[prop]) appTemplate[prop] = data[prop];
                            });
                        } else {
                            return $q.reject();
                        }
                    });
                };
            }
        };
    });

    module.directive('validateUrlExists', function($http, $q) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                let lastValue;
                ngModel.$asyncValidators.validateUrlExists = (modelValue, viewValue) => {
                    if (!viewValue || lastValue === viewValue) return $q.resolve();
                    lastValue = viewValue;
                    return $http.get(viewValue).then(({ status }) => status === 200 || $q.reject());
                };
            }
        };
    });
})(angular.module('rocket.components'));
